import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconDeliveryTruckFill';
/** Renders an SVG icon. */
const SvgDeliveryTruckFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path fill="currentColor" d="M10 28a3 3 0 1 0 0-6 3 3 0 0 0 0 6m12 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 6a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3 5 5 0 0 1 10 0h2c0-1.126.372-2.165 1-3V9a3 3 0 0 0-3-3zm6.707 5.293a1 1 0 0 0-1.414 1.414L12.586 15l-2.293 2.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414zm-5.115 3a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414l-.707-.707a1 1 0 0 0-1.414 0zM30 22a3 3 0 0 1-3 3 5 5 0 0 0-7-4.584V9a1 1 0 0 1 1-1h2.84a3 3 0 0 1 2.604 1.512l3.16 5.53a3 3 0 0 1 .396 1.49zm-8-6v-6h1.84a1 1 0 0 1 .868.504L27.848 16z"
      />
    </svg>
  );
};
SvgDeliveryTruckFill.displayName = displayName;
export default SvgDeliveryTruckFill;
